import React from 'react';
import styles from './ErrorMessage.module.css';
import { FiXCircle, FiAlertTriangle } from 'react-icons/fi'; // Иконка для ошибки
import { useIntl } from 'react-intl';

const ErrorMessage = ({ message, onDismiss }) => {
    const intl = useIntl();
    if (!message) return null;

    return (
        <div className={styles.errorWrapper}>
            <FiAlertTriangle className={styles.errorIcon} />
            <span className={styles.errorMessageText}>
        {/* Можно добавить префикс из локализации, если нужно */}
                {/* {intl.formatMessage({ id: "common.errorPrefix" })} */}
                {message}
      </span>
            {onDismiss && (
                <button onClick={onDismiss} className={styles.dismissButton} aria-label="Закрыть ошибку">
                    <FiXCircle />
                </button>
            )}
        </div>
    );
};

export default ErrorMessage;
